import { Injectable } from '@angular/core';

import { BaseService } from 'app/_services/base.service';
import { SettingsService } from 'app/_services/settings.service';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { SaveHoldingIntegration } from './_models/saveHoldingIntegration';
import { SuportGridviewSort } from 'app/support/_models/supportGridview';

@Injectable({ providedIn: 'root' })
export class SupportIntegrationManagementService extends BaseService {
    private _apiSupportUrl: string = `${environment.apiSupport}`;
    private _domain: string = '/holding-integration';

    private _sortDataSubject = new BehaviorSubject<SuportGridviewSort>({ enabled: true, sortedBy: 'lastUploadDate', isReverse: true, nullsFirst: true });
    public sortDataValue$ = this._sortDataSubject.asObservable();

    constructor(private config: SettingsService) {
        super();
    }

    public getById(holdingId: string) {
        return this.config.executeGet({ baseUrl: this._apiSupportUrl, url: `${this._domain}/${holdingId}`});
    }

    public getByPage(pageNumber: number, pageSize: number, filter: string = ''): Observable<any> {
      return this.config.executeGet({ baseUrl: this._apiSupportUrl, url: `${this._domain}/?currentPage=${pageNumber}&pageSize=${pageSize}&nameFilter=${filter}`} );
    }

    public getHoldings(isEditing: boolean): Observable<any> {
      return this.config.executeGet({ baseUrl: this._apiSupportUrl, url: `${this._domain}/holdings?isEditing=${isEditing}`} );
    }

    public editHoldingIntegration(integration: SaveHoldingIntegration) {
      return this.config.executePut({ baseUrl: this._apiSupportUrl, url: this._domain, body: integration });
    }

    public createHoldingIntegration(integration: SaveHoldingIntegration) {
      return this.config.executePost({ baseUrl: this._apiSupportUrl, url: this._domain, body: integration });
    }

    public getSortDataValue(): SuportGridviewSort {
        return this._sortDataSubject.value;
    }

    public setSortDataValue(value: SuportGridviewSort): void {
        this._sortDataSubject.next(value);
    }
}
